/** Avatar fallback: the first letters of the first two words, `?` when there is no name. */
export function contactInitials(name: string | null | undefined): string {
  return (
    (name ?? '')
      .split(' ')
      .slice(0, 2)
      .map((word) => word[0] ?? '')
      .join('')
      .toUpperCase() || '?'
  )
}
